
export const DEBUG = 0;
export const PRODUCT = 1;
export const ENV = PRODUCT;

export const BASE_ROUTE = ENV === DEBUG ? '' : '/company';
export const PROTOCOL = 'http';
export const DOMAIN = 'wellknit.com.cn:8082';
export const ROOT_ADDR = `${PROTOCOL}://${DOMAIN}`;
export const API_ADDR = `${ROOT_ADDR}/api`;
export const ACCESS_TOKEN = '1|z49ysCOzExXLw7g3Bg8rWKc75zP1q0r5FnjB1yE0';
export const SESSION_EXPIRED_CODE = 'Unauthenticated';
export const PAGE_SIZE = 10;



export const EXTEND = 0;
export const REPLACE = 1;

export const INIT = 0;
export const READY = 1;
export const IDLE = 2;

export const ROLE_EMPLOYEE = 0;
export const ROLE_RPOVIDER = 1;

export const DEFAULT_ROWS = 20;

